import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

export type FetchPixelTreeGraphs = () => void;

const fetchPixelTreeGraphs = (): AppThunk => async (dispatch: AppDispatch) => {
  await Promise.all([
    fetchReport("ads_by_month_ty_vs_ly", dispatch, {}),
    fetchReport("smbs_by_month_ty_vs_ly", dispatch, {}),
    fetchReport("ads_by_week_yoy", dispatch, {}),
    fetchReport("smbs_by_week_yoy", dispatch, {}),
  ]);
};

export default fetchPixelTreeGraphs;
